import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-background-50/60 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          className="text-lg md:text-xl font-heading font-bold text-foreground-950 tracking-tight whitespace-nowrap"
        >
          kakobuyspreadsheet.wtf
        </Link>

        <div className="hidden md:flex items-center gap-5">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/' ? 'text-foreground-950' : 'text-foreground-600 hover:text-foreground-950'
            }`}
          >
            <i className="ri-home-4-line mr-1"></i>
            Strona Główna
          </Link>
          <Link
            to="/kakobuy-spreadsheet-polska/"
            className={`text-sm transition-colors whitespace-nowrap ${
              location.pathname === '/kakobuy-spreadsheet-polska/' ? 'text-foreground-950 font-medium' : 'text-foreground-600 hover:text-foreground-950'
            }`}
          >
            <i className="ri-book-open-line mr-1"></i>
            Poradnik Zakupowy
          </Link>
          <Link
            to="/best-kakobuy-spreadsheet-2026/"
            className={`text-sm transition-colors whitespace-nowrap ${
              location.pathname === '/best-kakobuy-spreadsheet-2026/' ? 'text-foreground-950 font-medium' : 'text-foreground-600 hover:text-foreground-950'
            }`}
          >
            Best 2026
          </Link>
          <Link
            to="/artykul/kakobuy-spreadsheet-polska-2026/"
            className={`text-sm transition-colors whitespace-nowrap ${
              location.pathname === '/artykul/kakobuy-spreadsheet-polska-2026/' ? 'text-foreground-950 font-medium' : 'text-foreground-600 hover:text-foreground-950'
            }`}
          >
            Artykuły
          </Link>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-4 py-2 bg-foreground-950 text-background-50 rounded-full text-xs font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            kakobuy spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-4 py-2 bg-primary-500 text-background-50 rounded-full text-xs font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            buy it now
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full hover:bg-foreground-100/50 transition-colors cursor-pointer"
          aria-label="Menu"
        >
          <i className={`text-foreground-950 text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-foreground-100/50">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/"
              className="flex items-center gap-3 text-sm font-medium text-foreground-950 py-2"
            >
              <i className="ri-home-4-line text-base"></i>
              Strona Główna
            </Link>
            <Link
              to="/kakobuy-spreadsheet-polska/"
              className="flex items-center gap-3 text-sm text-foreground-700 py-2"
            >
              <i className="ri-book-open-line text-base"></i>
              Poradnik Zakupowy
            </Link>
            <Link
              to="/best-kakobuy-spreadsheet-2026/"
              className="flex items-center gap-3 text-sm text-foreground-700 py-2"
            >
              <i className="ri-star-line text-base"></i>
              Best 2026
            </Link>
            <Link
              to="/artykul/kakobuy-spreadsheet-polska-2026/"
              className="flex items-center gap-3 text-sm text-foreground-700 py-2"
            >
              <i className="ri-article-line text-base"></i>
              Artykuły
            </Link>
            <Link
              to="/artykul/najlepszy-kakobuy-spreadsheet/"
              className="flex items-center gap-3 text-sm text-foreground-700 py-2"
            >
              <i className="ri-medal-line text-base"></i>
              Najlepszy Spreadsheet
            </Link>
            <Link
              to="/artykul/kakobuy-spreadsheet-polska-ranking/"
              className="flex items-center gap-3 text-sm text-foreground-700 py-2"
            >
              <i className="ri-bar-chart-line text-base"></i>
              Ranking Polska
            </Link>
            <div className="pt-3 border-t border-foreground-100/50">
              <p className="text-xs text-foreground-400 mb-3">Kategorie produktów</p>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
                  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
                  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
                  { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
                  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
                  { name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
                  { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
                  { name: 'Underwear', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
                  { name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
                  { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
                  { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
                  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html' },
                  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html' },
                  { name: 'OtherStuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html' },
                ].map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="px-3 py-2 bg-foreground-50/70 rounded-lg text-xs text-foreground-700 hover:bg-foreground-100 transition-colors text-center cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <div className="flex flex-col gap-2 pt-3 border-t border-foreground-100/50">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-full px-4 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-semibold text-center hover:bg-foreground-800 transition-colors cursor-pointer"
              >
                kakobuy spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-full px-4 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold text-center hover:bg-primary-600 transition-colors cursor-pointer"
              >
                buy it now
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}